export default __webpack_public_path__ + "static/media/movipack_feature1hover.9da6046a.svg";